export default __webpack_public_path__ + "static/real1-ae9312e0050275659b3849bfff5ceb7a.png";